import {useMemo} from 'react'

import {safeResolveResponse, type SafeResolveResponseOptions} from '../utils/contentful'

export function useContentfulData(json: unknown, options?: SafeResolveResponseOptions): unknown {
  const legacyMode = options?.legacyMode

  return useMemo(() => {
    return safeResolveResponse(json, {legacyMode})
  }, [json, legacyMode])
}
